import { ROUTE_CONST } from "../constants/actiontypes";
import { config } from "./config";

export const getDomain = () => {
  const parsedData = window.location.pathname.split("/");
  return parsedData[1];
};

export function getRoute(type: string, clientName: string) {
  switch (type) {
    case ROUTE_CONST.HOME:
      return `${process.env.PUBLIC_URL}/${clientName}}`;
    case ROUTE_CONST.CARTDEFSELECTIONHOME:
      return `${process.env.PUBLIC_URL}/${clientName}`;
    case ROUTE_CONST.LOGIN:
      return `${process.env.PUBLIC_URL}/${clientName}/login`;
    case ROUTE_CONST.ITEMS:
      return `${process.env.PUBLIC_URL}/${clientName}/items`;

    case ROUTE_CONST.ITEMDETAIL:
      return `${process.env.PUBLIC_URL}/${clientName}/item/:id`;
    case ROUTE_CONST.CUSTOMERS:
      return `${process.env.PUBLIC_URL}/${clientName}`;
    case ROUTE_CONST.CARTDEFSELECTION:
      return `${process.env.PUBLIC_URL}/${clientName}/set`;
    case ROUTE_CONST.ORDERCONFIRMATION:
      return `${process.env.PUBLIC_URL}/${clientName}/orderconfirm/:id`;
    case ROUTE_CONST.DELETEORDERCONFIRMATION:
      return `${process.env.PUBLIC_URL}/${clientName}/deleteorderconfirm`;
    case ROUTE_CONST.CART:
      return `${process.env.PUBLIC_URL}/${clientName}/cart`;

    case ROUTE_CONST.STANDINGORDER:
      return `${process.env.PUBLIC_URL}/${clientName}/standingorder/:id`;
    case ROUTE_CONST.STANDINGORDERITEMS:
      return `${process.env.PUBLIC_URL}/${clientName}/standingorderitems/:addressid`;
    case ROUTE_CONST.ADDSTANDINGORDER:
      return `${process.env.PUBLIC_URL}/${clientName}/addstandingorder/:addressid`;

    case ROUTE_CONST.STANDINGORDERSUMMARY:
      return `${process.env.PUBLIC_URL}/${clientName}/standingordersummary`;

    case ROUTE_CONST.ERROR:
      return `${process.env.PUBLIC_URL}/${clientName}/error`;
    case ROUTE_CONST.PAGENOTFOUND:
      return `${process.env.PUBLIC_URL}/${clientName}/notfound`;
    case ROUTE_CONST.INVITATION:
      return `${process.env.PUBLIC_URL}/${clientName}/invitation/:id/:lang`;
    default:
      return `${process.env.PUBLIC_URL}/${clientName}}`;
  }
}
